<template>
  <div>
    <OnexAlert v-if="showDescription" :type="Notifications.info">
      {{ $t(draftMessage, { amount: draftAmount, date: formattedPaidToDate }) }}
    </OnexAlert>
    <OnexAlert v-if="isPaymentInProcess" :type="Notifications.warning">
      {{ $t('L_info_please_be_advised_that_a_bank') }}
    </OnexAlert>
    <v-card class="centerPage" v-if="!processCompleted">
      <LoadingIndicator :loading="!processCompleted" />
    </v-card>
    <div class="mt-4 pb-4" :class="$vuetify.display.xs ? 'pl-8' : 'px-8'">
      <!-- Check image showing routing and account number-->
      <v-dialog v-model="showcheck" max-width="880" :persistent="persistent">
        <v-card class="orangeTop">
          <v-card-title class="mb-4 d-flex flex-wrap justify-center align-start">
            <div class="w-100 text-right">
              <v-icon :icon="mdiClose" size="large" @click="showcheck = false" />
            </div>
            <h1 class="text-center w-100">
              {{ $t('L_how_to_find_the_routing_and_account_number') }}
            </h1>
          </v-card-title>
          <div class="d-flex justify-center">
            <v-img
              v-if="locale === 'en_US'"
              src="../../../components/PaymentMethod/components/StepTwo/check-mobile.svg"
              alt="check"
              max-width="95%"
            />
            <v-img
              v-else-if="locale === 'en_CA'"
              src="../../../components/PaymentMethod/components/StepTwo/CanadaCheckEn.png"
              alt="check"
              max-width="95%"
            />
            <v-img
              v-else-if="locale === 'fr_CA'"
              src="../../../components/PaymentMethod/components/StepTwo/CanadaCheckFr.png"
              alt="check"
              max-width="95%"
            />
          </div>
          <div v-if="locale === 'en_US'" class="d-flex flex-wrap justify-center">
            <div class="text-center text-1 font-weight-bold w-50">|</div>
            <div class="text-center text-1 font-weight-bold w-50">|</div>
            <div class="text-center w-50">
              {{ $t('L_routing_number') }}
            </div>
            <div class="text-center w-50">
              {{ $t('L_account_number') }}
            </div>
          </div>
          <div v-else class="d-flex justify-center px-6">
            <div class="text-center legend-text" :class="$vuetify.display.xs ? '' : 'pl-16'">
              {{ $t('L_routing_number') }}
            </div>
            <div class="text-center legend-text">
              {{ $t('L_institution_number') }}
            </div>
            <div class="text-center legend-text" :class="$vuetify.display.xs ? '' : 'pr-16'">
              {{ $t('L_account_number') }}
            </div>
          </div>

          <v-row class="mt-4 mb-4 align-center justify-center">
            <v-col cols="12" class="maxwidthButton2">
              <OnexButton color="primary" block @click="showcheck = false">
                {{ $t('L_OK') }}
              </OnexButton>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col cols="12">
          <v-row class="mr-0">
            <v-col cols="12">
              <h4>
                {{ $t('L_select_bank_account_type') }}
              </h4>
            </v-col>
            <!-- Checking vs Savings -->
            <v-col cols="12" sm="4" class="clickable mb-2 pr-0">
              <div
                class="text-left d-flex align-center"
                :class="paymentMethod === 0 ? 'green-border-box' : 'gray-border-box'"
                @click="setPaymentMethod(0)"
              >
                <v-icon
                  :color="paymentMethod === 0 ? '#39ac4b' : '#02579e'"
                  class="mx-1"
                  :icon="mdiBank"
                />
                <span
                  class="font-weight-semibold"
                  :class="{ 'font-size--14': $vuetify.display.sm }"
                >
                  {{ $t('L_checking') }}
                </span>
                <v-spacer></v-spacer>
                <v-icon
                  color="#39ac4b"
                  v-if="paymentMethod === 0"
                  class="greenCheckRight"
                  :icon="mdiCheckCircle"
                />
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="clickable mb-2 pr-0">
              <div
                class="text-left d-flex align-center"
                :class="paymentMethod === 1 ? 'green-border-box' : 'gray-border-box'"
                @click="setPaymentMethod(1)"
              >
                <v-icon
                  :color="paymentMethod === 1 ? '#39ac4b' : '#02579e'"
                  class="mx-2"
                  :icon="mdiPiggyBank"
                />
                <span
                  class="font-weight-semibold"
                  :class="{ 'font-size--14': $vuetify.display.sm }"
                >
                  {{ $t('L_savings') }}
                </span>
                <v-spacer></v-spacer>
                <v-icon
                  color="#39ac4b"
                  v-if="paymentMethod === 1"
                  class="greenCheckRight"
                  :icon="mdiCheckCircle"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <!-- Checking vs Savings -->
        <v-col cols="12">
          <v-row wrap mt-4 mb-4 v-if="paymentMethod !== ''">
            <div>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <h4>{{ $t('L_please_enter_the_bank_account_information') }}</h4>
                  </v-col>
                </v-row>
                <!-- Routing Account Bank Name-->
                <v-row class="ml-0">
                  <v-col cols="12" sm="6" class="d-flex flex-column pl-0">
                    <OnexRoutingNumber
                      v-model="routingNumber"
                      :label="$t('L_routingUS_transitAndInstitutionCAN')"
                      :country="getCountry"
                      required
                      :prepend-validations="[routingNumberRule]"
                    ></OnexRoutingNumber>
                    <OnexText
                      tabindex="-1"
                      v-model="bankName"
                      :label="$t('L_bank_name')"
                      :rules="[bankNameUpdate]"
                      readonly
                    ></OnexText>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    class="d-flex flex-column"
                    :class="$vuetify.display.xs ? 'pl-0' : 'pl-4'"
                  >
                    <OnexAccountNumber
                      v-model="bankAccountNumber"
                      :label="$t('L_account_number')"
                      :country="getCountry"
                      required
                      @copy.prevent
                    ></OnexAccountNumber>
                    <OnexAccountNumber
                      v-model="verifyBankAcctNumber"
                      :label="$t('L_confirm_account_number')"
                      required
                      :country="getCountry"
                      :appendValidations="[accountVerifyingRule]"
                      @paste.prevent
                    ></OnexAccountNumber>
                  </v-col>
                </v-row>
                <!-- ? Where to find Bank Routing and Account Number -->
                <v-row text-left>
                  <v-col cols="12" @click="showCheckImage" class="pb-0">
                    <span>
                      <v-icon class="mr-2 cursor-pointer" color="#0c6dca" :icon="mdiHelpCircle" />
                    </span>
                    <span class="font-weight-bold font-size--16 blueFont cursor-pointer">
                      {{ $t('L_where_to_find_bank_routing_and_account_number') }}
                    </span>
                  </v-col>
                  <v-col cols="12" class="mt-4 font-size--16 pt-0">
                    <div>
                      {{ $t('L_by_continuing_with_this_payment_method_you_agree') }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-row>

          <v-row class="d-flex justify-end my-4">
            <v-col cols="12" sm="4" md="3" class="px-4">
              <OnexButton block variant="outlined" color="outlined" @click="cancel">
                {{ $t('L_cancel') }}
              </OnexButton>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="px-4">
              <OnexButton block :disabled="badForm" @click="goToStepThree">
                {{ $t('L_continue') }}
              </OnexButton>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapActions, mapWritableState } from 'pinia';
import {
  OnexAccountNumber,
  OnexRoutingNumber,
  OnexText,
  OnexButton,
  OnexBoolean,
  OnexSelect,
  Countries,
  Notifications,
  OnexAlert,
} from '@primerica/onex-ui-lib';
import { useVuelidate } from '@vuelidate/core';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { formatDate } from '@/shared/util/formatters';
import LoadingIndicator from '../../../../../components/LoadingIndicator.vue';
import { mdiClose, mdiHelpCircle, mdiBank, mdiPiggyBank, mdiAlert, mdiCheckCircle } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'PayMethodChangeStepTwo',
  components: {
    LoadingIndicator,
    OnexAccountNumber,
    OnexRoutingNumber,
    OnexText,
    OnexButton,
    OnexBoolean,
    OnexSelect,
    OnexAlert,
    Countries,
  },
  data: () => ({
    v$: useVuelidate(),
    paymentMethod: '',
    bank: '',
    accountType: 0,
    accountHolder: '',
    bankAccountNumber: '',
    verifyBankAcctNumber: '',
    routingNumber: '',
    datepicker: '01',
    showDescription: false,
    accountHolderErrorMessages: [],
    processCompleted: true,
    Countries,
    showcheck: false,
    persistent: true,
    isBankAPICalled: false,
    mdiClose,
    mdiHelpCircle,
    mdiBank,
    mdiPiggyBank,
    mdiAlert,
    mdiCheckCircle,
    Notifications,
  }),
  props: {
    showDatePicker: {
      type: Boolean,
      default: false,
    },
    // existingBankInfo: {
    //   type: Object,
    //   required: true,
    // },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
      dateFormat: 'getDateFormat',
    }),
    ...mapState(usePolicyStore, {
      paymentData: 'paymentData',
      policyData: 'currentPolicy',
      preLoadBank: 'preLoadBank',
    }),
    ...mapWritableState(usePolicyStore, {
      storeBankName: 'bankName',
      bankNameResponse: 'bankNameResponse',
    }),
    getCountry() {
      return this.isCanadaPolicy ? Countries.CA : Countries.US;
    },
    routingNumberRule() {
      return this.isCanadaPolicy
        ? this.routingNumber.length === 8 || this.$t('L_bank_transit_number_must_be_eight_digits')
        : this.routingNumber.length === 9 || this.$t('L_bank_routing_number_must_be_nine_digits');
    },
    accountVerifyingRule() {
      return () =>
        this.verifyBankAcctNumber === this.bankAccountNumber ||
        this.$t('L_verify_bank_account_number_must_be_same');
    },
    bankNameUpdate() {
      if (this.routingNumber === '') this.readonly = '';
      else if (this.routingNumber != '' && this.routingNumber.length === 9) this.readonly = '';
    },
    isPaymentInProcess() {
      return this.policyData?.paymentInfo?.PayInProcess === '1';
    },
    bankName() {
      const name = this.bankNameResponse?.[0]?.name;
      return name || this.storeBankName || this.bank;
    },
    accountOptions() {
      return [
        {
          label: this.$t('L_savings_account'),
          value: this.bankAccountType === 3 ? 0 : 1,
        },
        {
          label: this.$t(this.checkingAccount),
          value: this.bankAccountType === 3 ? 1 : 0,
        },
      ];
    },
    badForm() {
      return (
        this.paymentMethod === '' ||
        this.bankName === '' ||
        this.v$.$invalid ||
        this.bankAccountNumber.length === 0 ||
        this.verifyBankAcctNumber.length === 0 ||
        this.routingNumber.length === 0
      );
    },
    clientName() {
      return this.policyData?.owner?.name;
    },
    isCanadaPolicy() {
      return this.policyData?.isCanadaPolicy;
    },
    checkingAccount() {
      return this.isCanadaPolicy ? 'L_chequing_account' : 'L_checking_account';
    },
    bankAccountType() {
      return this.policyData?.paymentInfo?.accountType;
    },
    formattedPaidToDate() {
      return formatDate(this.policyData?.paymentInfo?.paidToDate, this.dateFormat);
    },
    draftMessage() {
      // const paidToDate = moment(this.policyData?.paymentInfo?._paidToDate).format('YYYY-MM-DD');
      // const currentDate = moment().format('YYYY-MM-DD');
      const paidToDate = new Date(this.policyData?.paymentInfo?.paidToDate);
      const currentDate = new Date();
      if (paidToDate < currentDate) {
        return 'L_there_will_be_a_draft_generate_past_draft_date';
      }
      return 'L_there_will_be_a_draft_generate';
    },
    // errorMessages(): string[] {
    //   interface ValidationMessages {
    //     [key: string]: string;
    //   }

    //   interface FormInput {
    //     $dirty: boolean;
    //     $error: boolean;
    //     [key: string]: unknown;
    //   }

    //   const errors: string[] = [];
    //   const validationMessages: ValidationMessages = Object.assign(
    //     {},
    //     messages.accountHolder,
    //     this.validationMessages
    //   );
    //   const formInput: FormInput | undefined = this.formInput;
    //   if (!formInput?.$dirty) {
    //     return errors;
    //   }
    //   if (formInput.$error) {
    //     // If there is an error on the field
    //     Object.keys(validationMessages).forEach((type: string) => {
    //       if (
    //         formInput[type] === false &&
    //         Object.prototype.hasOwnProperty.call(validationMessages, type)
    //       ) {
    //         errors.push(validationMessages[type]);
    //       }
    //     });
    //     if (errors.length === 0) {
    //       // If no messages have been added for this error
    //       errors.push(messages.generic.invalid);
    //     }
    //   }
    //   return errors.map((msg: string) =>
    //     typeof this.$t !== 'undefined' ? this.$t(msg, { length: this.minLengthInput }) : msg
    //   );
    // },
  },
  methods: {
    ...mapActions(useGlobalStore, {
      removeAlerts: 'removeAlerts',
    }),
    ...mapActions(usePolicyStore, {
      getBankInfo: 'getBankInfo',
    }),
    clearBank() {
      this.storeBankName = '';
      // this.bank = '';
      this.bankNameResponse = null;
    },
    showCheckImage() {
      this.showcheck = true;
    },
    setPaymentMethod(method: number) {
      if (method === 1) {
        // Savings Account
        this.paymentMethod = 1;
        if (this.bankAccountType === 3) {
          this.accountType = 0;
        } else {
          this.accountType = 1;
        }
      } else if (method === 0) {
        // Checking Account
        this.paymentMethod = 0;
        if (this.bankAccountType === 3) {
          this.accountType = 1;
        } else {
          this.accountType = 0;
        }
      }
    },
    async checkRouting() {
      if (
        (this.isCanadaPolicy && this.routingNumber.length === 8) ||
        (!this.isCanadaPolicy && this.routingNumber.length === 9) ||
        this.bankName.length > 0
      ) {
        this.bank = '';
        const country = this.isCanadaPolicy ? 'CA' : 'US';
        const payload = {
          policyNo: this.policyData?.contractId,
          routingNumber: this.routingNumber,
          country,
        };
        await this.getBankInfoMethod(payload);

        // if (this.v$.routingNumber.$error) {
        //   this.clearBank();
        // }
        this.isBankAPICalled = true;
      }
    },
    async getBankInfoMethod(payload: { policyNo: string; routingNumber: string; country: string }) {
      this.processCompleted = false;
      await this.getBankInfo(payload)
        .then((response: boolean) => {
          if (!response) {
            this.clearBank();
          }
          this.processCompleted = true;
        })
        .catch(() => {
          this.clearBank();
          this.processCompleted = true;
        });
    },
    async goToStepThree() {
      await this.checkRouting();
      if (this.bankName !== '') {
        const bankInfo = {
          policyNumber: this.policyData?.contractId,
          reqMode: '01',
          draftDay: this.datepicker,
          nextDraftDate: this.formattedPaidToDate,
          nextCycleDate: this.policyData?.paymentInfo?.nextCycleDate,
          // MYP-2480 Change to allow users to type the name of account holder
          accountName: this.accountHolder, // this.policyData?.owner?.name,
          routingNumber: this.routingNumber,
          accountNumber: this.bankAccountNumber,
          accountType: this.accountType,
          draftAmount: this.policyData?.paymentInfo?.PACPremium,
          bankName: this.bankName,
          isCanada: this.policyData?.isCanadaPolicy,
          accountTypeString:
            this.accountType === 0 ? this.$t(this.checkingAccount) : this.$t('L_savings'),
        };
        this.bankInfo = bankInfo;
        this.bank = this.bankName;
        this.$emit('goToStepThree', bankInfo);
      }
    },
    cancel() {
      // this.clearBank();
      // this.bank = '';
      this.$emit('cancel');
    },
  },
  watch: {
    routingNumber() {
      this.checkRouting();
    },
  },
  mounted() {
    this.processCompleted = true;
    this.accountHolder = this.policyData?.owner?.name;
    if (this.preLoadBank) {
      this.bank = this.paymentData?.bankName;
      this.bankAccountNumber = this.paymentData?.accountNumber;
      this.verifyBankAcctNumber = this.paymentData?.accountNumber;
      this.accountType = this.bankAccountType === '3' ? 1 : 0;
      this.datepicker = this.policyData?.paymentInfo?.autoDraftPaymentDate;
      this.showcheck = false;
    }
    this.removeAlerts('payment');
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.maxwidthButton2 {
  max-width: 295px;
  width: 295px;
  font-size: 16px;
}
.blueFont {
  color: #0c6dca;
  font-weight: 600;
}
.valid-bank.v-text-field > .v-input__control > .v-input__slot:before {
  display: none !important;
}
.valid-bank.v-text-field > .v-input__control > .v-input__slot:after {
  display: none !important;
}
.gray-border-box {
  border: 2px solid #e3e3e3;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #ffffff;
  max-width: 295px;
}
.green-border-box {
  border: 2px solid #39ac4b;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #d8f8dd;
  max-width: 295px;
}
.greenCheckRight {
  float: right;
  margin-right: 5px;
}
.clickable {
  cursor: pointer;
}
.centerPage {
  position: absolute;
  top: 50%;
  left: 50%;
}
.legend-text {
  width: 33.3%;
}
</style>
